import svgUrl from "ni:svgr;t7Xn1LumrxApHz9nriD-tNrUKAoUeM9vEAZFZP-bnzo";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const UiCsvFileSIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M8 2H3v12h9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5l4 4v2h-1V5H9a1 1 0 0 1-1-1V2ZM6 9a1 1 0 0 1 1-1h1v1H7v2h1v1H7a1 1 0 0 1-1-1V9Zm5-1a2 2 0 0 0-2 2h1a1 1 0 0 1 1-1h1V8h-1Zm1 2a2 2 0 0 1-2 2H9v-1h1a1 1 0 0 0 1-1h1Zm2-2h-1v2.151l1.084 1.626a.5.5 0 0 0 .832 0L16 10.151V8h-1v1.849l-.5.75-.5-.75V8Z" clipRule="evenodd" /></svg>;
const Memo = memo(UiCsvFileSIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "ui-node-icon(UiCsvFileSIcon)";
}